import { scoreOf } from "./homeUtils";

// 홈 맨 위의 '아이 상태'. 보는 사람은 주로 엄마다(2026-10-26 대표). 리포트와 틀린 문제가 바로 보여야 한다.

// 최근 점수 칸. 점수가 있는 가장 최근에 끝낸 것.
export const findRecentScored = (finishedList) => finishedList.find((item) => scoreOf(item) !== null) || null;

// 점수를 누르면 무엇을 보게 되는지 그대로 적는다. 다 맞았으면 틀린 문제가 없다.
export const reviewLinkTextOf = (item) => {
  if (item.type === "class_content") return "알림장 보기";
  if (item.type === "paper_assignment") return "첨삭 보기";
  const score = scoreOf(item);
  return score && score.rate >= 100 ? "채점 보기" : "틀린 문제 보기";
};

export const noteTextOf = (note) => {
  const comment = String(note.comment || "").trim().split("\n")[0];
  return comment || `${note.level_name || ""} 알림장`.trim();
};
